import axios from 'axios';

/**
 * 조직 API(백엔드 modules/org/orgRouter.js) — 연결 관리의 「조직」 탭 · 수집 조회 공유 · 연결의 조직 공개가 쓴다.
 * @param {string} base `.../sql-developer` 까지의 주소
 */
export function orgApi(base) {
  const u = `${base}/orgs`;
  const enc = encodeURIComponent;
  return {
    mine: () => axios.get(u).then(r => r.data.data || []),
    create: (name) => axios.post(u, { name }).then(r => r.data.data),
    join: (inviteCode) => axios.post(`${u}/join`, { inviteCode }).then(r => r.data.data),
    rename: (id, name) => axios.put(`${u}/${enc(id)}`, { name }).then(r => r.data.data),
    inviteCode: (id) => axios.get(`${u}/${enc(id)}/invite-code`).then(r => r.data.data.inviteCode),
    regenerateInvite: (id) => axios.post(`${u}/${enc(id)}/invite-code`).then(r => r.data.data.inviteCode),
    members: (id) => axios.get(`${u}/${enc(id)}/members`).then(r => r.data.data || []),
    addMember: (id, usrid) => axios.post(`${u}/${enc(id)}/members`, { usrid }).then(r => r.data.data),
    approve: (id, usrid) => axios.post(`${u}/${enc(id)}/members/${enc(usrid)}/approve`).then(r => r.data.data),
    reject: (id, usrid) => axios.post(`${u}/${enc(id)}/members/${enc(usrid)}/reject`).then(r => r.data),
    setRole: (id, usrid, role) => axios.put(`${u}/${enc(id)}/members/${enc(usrid)}/role`, { role }).then(r => r.data.data),
    remove: (id, usrid) => axios.delete(`${u}/${enc(id)}/members/${enc(usrid)}`).then(r => r.data),
    leave: (id) => axios.delete(`${u}/${enc(id)}/membership`).then(r => r.data),
    setConnectionOrg: (connId, orgId, orgWrite) => axios.put(`${u}/connections/${enc(connId)}`, { orgId, orgWrite }).then(r => r.data),
  };
}
